<i18n src="@/locales/views/packing_house/production/uniq_final_packing_list/base.yml" lang="yaml"></i18n>
<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title" v-if="packing_house_process">
      {{ $t("labels.module_name") }}<span class="space-icon"></span
      ><i class="fa-solid fa-chevron-right fa-xs"></i
      ><span class="space-icon"></span>{{ packing_house_process.name }}
    </h1>
  </div>
</template>

<script>
import Requester from "@/views/packing_house/requesters/production/uniq_final_packing_list.js";

export default {
  name: "AEProductionBasicContainerExportAgroExporterProcessHeader",
  components: {},
  props: ["packing_house_process_id"],
  data() {
    return {
      packing_house_process: null,
    };
  },
  methods: {
    fetchAgroExporterProcess: async function () {
      let response =
        await Requester.fetchPackingHouseProcess(
          this.packing_house_process_id
        );
      this.packing_house_process = response.data;
    },
  },
  created() {
    this.checkIfAuthenticated();
    this.fetchAgroExporterProcess();
  },
};
</script>

